let BACKEND_SERVER = null;
let SERVER = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {

  //Localhost
  //SERVER = "http://localhost:5057/";
  //BACKEND_SERVER = "http://localhost:5057/api/";

  //Paycons
  //SERVER = "https://payconsapi.prowesserp.in/";
  // BACKEND_SERVER = "https://payconsapi.prowesserp.in/api/";

  //IIPL   
  SERVER = "https://hrapi.infoinnovative.com/";
  BACKEND_SERVER = "https://hrapi.infoinnovative.com/api/";

  //Demo
  //SERVER = "https://demoapi.prowesshr.in/";
  //BACKEND_SERVER = "https://demoapi.prowesshr.in/api/"; 

  //Demo1
  //SERVER =         "http://demo1api.prowesshr.in/";
  //BACKEND_SERVER = "http://demo1api.prowesshr.in/api/";

  //Adroit
  //SERVER =         "https://adroitapi.prowesshr.in/";
  //BACKEND_SERVER = "https://adroitapi.prowesshr.in/api/";


}


export const API_SERVER = BACKEND_SERVER;
export const Backend_Api = SERVER;